import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import IntroCart from './introCart';

/** Board order is admin-controlled via the "Position" field on each member. */
function sortBoardMembers(members) {
  if (!members || !members.length) return members || [];

  return [...members].sort((a, b) => (a.position || 0) - (b.position || 0));
}

class Board extends Component {
  render() {
    const { heading, members } = this.props.board;
    const { user } = this.props;
    const sortedMembers = sortBoardMembers(members).filter(member => member.title && member.title.trim());

    return (
      <div className="boardOfDirectors">
        { user ? (user.isAdmin || user.role?.some((elem) => ['featuredCartsAdmin'].includes(elem))) &&
          <Link className="admin-btn" to="/about/board">Edit</Link> : null
        }

        <h2>{heading}</h2>
        <div className="boardOfDirectors-grid">
          {sortedMembers.map(member => (
            <IntroCart member={member} key={member._id} />
          ))}
        </div>
    </div>
    );
  }
}
 
export default Board;